<div class="row-layout">
  <ng-content></ng-content>
</div>
